"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forecastFailureKind = forecastFailureKind;
exports.needsNotice = needsNotice;
exports.finishSetup = finishSetup;
const httpStatus_1 = require("./httpStatus");
/**
 * Which kind of forecast failure an error is: a refusal, or a failed request.
 *
 * The status is read through `httpErrorStatus`, which understands BOTH clients'
 * error shapes: web's AxiosError (`response.status`) and mobile's ApiClientError
 * (`status`). This used to duck-type on `response.status` alone, claiming to serve
 * both apps. It served only web: every mobile 400 read as `failed`, so mobile told
 * a user whose bank had not sent recurring data yet that the request had failed
 * (BEN-141 MRT-004 sweep). Keep the read in `httpErrorStatus`, not inline here.
 */
function forecastFailureKind(err) {
    const status = (0, httpStatus_1.httpErrorStatus)(err);
    if (status === 400)
        return "not-built";
    // T1-W01: the paywall. Web's SubscriptionRequired and mobile's ApiClientError both
    // carry status 402, which httpErrorStatus reads.
    if (status === 402)
        return "needs-plan";
    return "failed";
}
/** True when setup ended without a forecast and the user must be told first. */
function needsNotice(outcome) {
    return (outcome === "not-built" || outcome === "failed" || outcome === "needs-plan");
}
/**
 * Run the end of setup and report what happened. For a {@link needsNotice}
 * outcome the caller still owes `completeOnboarding`, when the user goes on.
 * Only `completeOnboarding` failing throws — the one case where setup did NOT
 * finish, which the step answers with its "Setup hiccup" retry.
 */
async function finishSetup(deps) {
    // A failed accounts lookup says nothing about whether a bank exists, so it
    // falls through to asking the engine, which answers either way.
    const hasBank = await deps.hasBank().catch(() => true);
    let outcome = "no-bank";
    if (hasBank) {
        try {
            await deps.generateForecast();
            outcome = "built";
        }
        catch (err) {
            outcome = forecastFailureKind(err);
        }
    }
    if (!needsNotice(outcome))
        await deps.completeOnboarding();
    return outcome;
}
//# sourceMappingURL=setupCompletion.js.map